import { Button } from "@elaniintc/goes-design-system";
import React, { useEffect, useRef, useState } from "react";

export interface DropdownItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

export interface NewFaqDdItem extends DropdownItem {
  faqId: string;
}

export interface DropdownProps {
  buttonLabel: React.ReactNode;
  items: (DropdownItem | NewFaqDdItem)[];
  buttonClassName?: string;
  dropdownClassName?: string;
}

const CreateDropdown: React.FC<DropdownProps> = ({
  buttonLabel,
  items,
  buttonClassName = "px-4 py-2",
  dropdownClassName = "absolute right-0 z-10 mt-2 w-64 bg-neutral-object rounded-xl shadow-lg border border-neutral",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => setIsOpen((v) => !v);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () =>
      document.removeEventListener("click", handleClickOutside, true);
  }, []);

  return (
    <div ref={containerRef} className="relative inline-block text-left">
      <Button
        variant="default"
        onClick={toggleOpen}
        className={buttonClassName}
      >
        {buttonLabel}
      </Button>

      {isOpen && (
        <div className={dropdownClassName}>
          <ul className="py-1">
            {items.map((item, idx) => (
              <li key={idx}>
                <button
                  onClick={() => {
                    item.onClick?.();
                    setIsOpen(false);
                  }}
                  className="w-full text-left px-4 py-2 text-body hover:bg-neutral-object-accent-quiet flex justify-between items-center cursor-pointer"
                >
                  <span>{item.label}</span>
                  {item.icon}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CreateDropdown;
